import { MarkerClusterer } from "@googlemaps/markerclusterer";

class FindStoreGoogleMap {
    constructor() {
        this.$ = jQuery;
        let self = this;
        self.init();

        if (document.getElementById("map-mobile")) {
            self.initMap(document.getElementById("map-mobile"), '');
        }

        if (document.getElementById("map-desktop")) {
            self.initMap(document.getElementById("map-desktop"), '');
        }

        let map;
        let markers;
    }

    /**
     * initMap
     *
     * Renders a Google Map onto the selected jQuery element
     *
     * @param   jQuery $el The jQuery element.
     * @return  object The map instance.
     */
    initMap($el, pos) {
        let $ = jQuery;
        let zoom, center;

        let $markers = JSON.parse($el.dataset.markers);

        // Removes points of intrest from the map
        let removeDefaultLabels = [
            {
                featureType: "poi",
                elementType: "labels",
                stylers: [
                    { visibility: "off" }
                ]
            }
        ];

        if ('' == pos) {
            zoom = 4
            center = { lat: 64.3910011, lng: 16.7393019 };
        } else {
            zoom = 8
            center = pos
        }

        // Create generic map.
        let mapArgs = {
            zoom: zoom,
            center: center,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            mapTypeControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false,
            zoomControl: false,
            styles: removeDefaultLabels,
        };

        /* ----Init Map ----- */

        const map = new google.maps.Map($el, mapArgs);
        this.map = map

        /* ----Init Markers ----- */

        const markers = $markers.map((m) => {
            let position = new google.maps.LatLng(m.lat, m.lng);
            let icon = m.icon

            const marker = new google.maps.Marker({
                position: position,
                icon: icon,
                animation: google.maps.Animation.DROP,
                map: this.map,
            })

            return marker
        })

        this.markers = markers

        /* ----Init Markers Cluster ----- */

        const renderer = {
            render({ count, position }) {
                return new google.maps.Marker({
                    label: { text: String(count), color: "white", fontSize: "12px" },
                    position,
                    icon: {
                        url: `${wpurl.site}/resources/dist/images/marker-cluster.svg`,
                        scaledSize: new google.maps.Size(45, 45),
                    },
                    // adjust zIndex to be above other markers
                    zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
                })
            }
        }

        const clusterer = new MarkerClusterer({
            map,
            markers,
            renderer
        });
    }

    /**
     * Main method. Used for setting up other methods
     *
     */
    init() {
        let $ = jQuery;
        let self = this;

        $(document).ready(function () {
            $('#find-store .store-card').each(function () {
                self.pickStore($(this));
            });

            $('#find-store .close-to-you').click(function () {
                self.searchByPosition(self);
            });

            self.searchByInput();
        });
    }

    /**
     * Responsible for displaying more information on each store
     *
     * @param {jQuery selector} $el
     */
    pickStore($el) {
        $el.on('click', function () {
            if (!$el.hasClass('is-active')) {
                $el.addClass('is-active')
            } else {
                $el.removeClass('is-active')
            }
            $el.children('.btn-wrapper').slideToggle(300);
        });
    }

    /**
     * Responsible for handling user input.
     *
     */
    searchByInput() {
        let $ = jQuery;
        let self = this;

        // Stop form submit
        $('#find-store #find-store-form').submit(function (e) {
            e.preventDefault();
        });

        let input = document.getElementById('find-store-input');
        let options = {
            componentRestrictions: {
                country: 'se',
            },
        };

        // input.addEventListener('keyup', function(e) {
        //     if (e.keyCode === 13) {
        //         const query = input.value;
        //         if (query) {
        //             self.showResult(self, query);
        //         }
        //     }
        // });
        if(input instanceof HTMLElement){
            const AUTOCOMPLETE = new google.maps.places.Autocomplete(input, options);
            AUTOCOMPLETE.setFields(['address_components', 'geometry', 'icon', 'name']);
            AUTOCOMPLETE.addListener('place_changed', () => {
                const PLACE = AUTOCOMPLETE.getPlace();

                if (PLACE.length == 0) {
                    console.log('Did not find any places');
                    return;
                }

                if (typeof PLACE.geometry === 'undefined') {
                    console.log('Not a valid position');
                    return;
                }

                const POS = {
                    lat: PLACE.geometry.location.lat(),
                    lng: PLACE.geometry.location.lng(),
                };

                self.showResult(self, POS);
            });
        }
    }


    /**
     * Responsible for handling positional coordinates
     *
     * @param {this} self
     */
    searchByPosition(self) {
        // Try HTML5 geolocation.
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function (position) {
                const POS = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                };

                self.showResult(self, POS);
            }, function () {
                alert("Error: The Geolocation service failed.");
            });
        } else {
            // Browser doesn't support Geolocation
            alert("Error: Your browser doesn't support geolocation.");
        }
    }

    /**
     * Responsible for displaying results based on either search coordinates or positional coordinates
     *
     * @param {this} self
     * @param {object} origin
     */
    showResult(self, origin) {
        let $ = jQuery;
        
        var inputUser = $('#find-store-input').val();
        var arr = inputUser.split(",");
        var userTown = arr[0].toLowerCase();

        const bounds = new google.maps.LatLngBounds();
        let itemsProcessed = 0;

        var foundTown;
        $('#find-store .store-card').each((i, el) => {
            itemsProcessed++;
            // Display all elements for each request
            if ($(el).hasClass('is-hidden')) {
                $(el).removeClass('is-hidden');
            }

            let destination = { lat: parseFloat($(el).data('lat')), lng: parseFloat($(el).data('lng')) };
            let { lat, lng } = destination
            var streetName = $(el).data('town');

            let service = new google.maps.DistanceMatrixService();
            let request = {
                origins: [origin],
                destinations: [destination],
                travelMode: google.maps.TravelMode.DRIVING,
                unitSystem: google.maps.UnitSystem.METRIC,
                avoidHighways: false,
                avoidTolls: false,
            }

            if(streetName == userTown) {
                foundTown = $(el);
            }

            setTimeout(() => {
                service
                    .getDistanceMatrix(request)
                    .then(res => {
                        // console.log(res)

                        if (res.rows[0].elements.length > 0) {

                            $(el).attr('data-distance',res.rows[0].elements[0].distance.value);

                            // If the distance from the origin to the destination is more the 100 kilometers, hide it from the list
                            if (res.rows[0].elements[0].distance.value > 100000) {
                                $(el).addClass('is-hidden');
                            } else {
                                let position = new google.maps.LatLng(lat, lng);
                                bounds.extend(position);
                            }

                        } else {
                            window.alert('No results found');
                        }
                    })
            }, 6 * i);

            if (itemsProcessed === $('#find-store .store-card').length) {
                this.updateMap(bounds);
            }
        });

        $(".stores-wrapper").prepend(foundTown);

    }

    updateMap(bounds) {

        setTimeout(() => {
            let totalStoreNumber = this.$('#find-store .store-card').length;
            let filteredStoreNumber = this.$('#find-store .store-card:not(.is-hidden)').length;
            this.$('#find-store .number-of-stores').empty();
            this.$('#find-store .number-of-stores').text(`${filteredStoreNumber} av ${totalStoreNumber} butiker`);

            if (!this.$('.mm__find-store-map.mobile').hasClass('is-hidden')) {
                this.$('.mm__find-store-map.mobile').addClass('is-hidden');
            }

            this.map.fitBounds(bounds);
            this.map.panToBounds(bounds);

            // Show nearest store first in store location listing
            if(this.$('#find-store .stores-wrapper').length){
                var $wrapper = this.$('#find-store .stores-wrapper');
                $wrapper.find('.store-card:not(.is-hidden)').sort(function (a, b) {
                    return +a.dataset.distance - +b.dataset.distance;
                })
                .appendTo( $wrapper );
            }

        }, 1500);
    }
}

export default FindStoreGoogleMap;
